import { render, staticRenderFns } from "./error-book.vue?vue&type=template&id=38818621&scoped=true&"
import script from "./error-book.vue?vue&type=script&lang=js&"
export * from "./error-book.vue?vue&type=script&lang=js&"
import style0 from "./error-book.vue?vue&type=style&index=0&id=38818621&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38818621",
  null
  
)

export default component.exports